import React from "react";
import closeImage from "assets/Icon_Notification_Cross.png";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastPosition } from "react-toastify";
import { JSXElement } from "@babel/types";

export type ToastConfig = {
  toastId?: string;
  position?: ToastPosition;
  autoClose?: number | false | undefined;
  hideProgressBar?: boolean;
  closeButton?: boolean;
  delay?: number;
};

export const toastConfig: ToastConfig = {
  toastId: "ToastMessageContainer",
  position: toast.POSITION.BOTTOM_CENTER,
  autoClose: 5000,
  hideProgressBar: true,
  closeButton: false,
  delay: 500,
};

export type ToastMessageType = {
  toastData:
    | {
        title: string;
        text: string | null | JSX.Element;
      }[]
    | null;
  className: string;
};

const ToastMessage: React.FC<ToastMessageType> = ({ toastData, className }) => {
  if (toastData) {
    return (
      <div className={`ToastContainer ${className}`}>
        <div className="ToastItems">
          {toastData.map((item, i) => {
            return (
              <div key={i} className="ToastItem">
                <div className="Title">
                  {item.title
                    ? item.title === "Error Label"
                      ? "Error"
                      : item.title
                    : ""}
                </div>

                {item.text && typeof item.text === "string" ? (
                  <div className="Text">{item.text}</div>
                ) : (
                  item.text
                )}
              </div>
            );
          })}
        </div>

        <img src={closeImage} alt="close" className="CloseButton" />
      </div>
    );
  } else {
    return null;
  }
};

export default ToastMessage;
